import type { IDeviceTokenRepository } from '../repositories/IDeviceTokenRepository.js';

interface Deps { deviceTokenRepository: IDeviceTokenRepository; }

export function createRemoveDeviceTokenUseCase({ deviceTokenRepository }: Deps) {
  return function removeDeviceToken(fcmToken: string): Promise<void> {
    return deviceTokenRepository.remove(fcmToken);
  };
}
